import React from "react";
import Service_outer_card from "../../../Common_Component/Service_outer_card/Service_outer_card";

function Digital_Media() {
  const data = [
    {
      id: 1,
      title: "Social Media Marketing",
      description:
        "Social Media Marketing is a dynamic & essential tool to connect with your audience, build brand awareness, and drive conversions.",
      bgImgSrc: "/Assets/Images/Service/Services/DigitalMedia/bgimg1.png",
      MainImgSrc: "/Assets/Images/Service/Services/DigitalMedia/img1.png",
      baseLink: "/digitalmedia-services",
    },

    {
      id: 2,
      title: "Pay-Per-Click (PPC) Advertising",
      description:
        "Radio advertising continues to be one of the most reliable ways to connect with audiences.",
      bgImgSrc: "/Assets/Images/Service/Services/DigitalMedia/bgimg2.png",
      MainImgSrc: "/Assets/Images/Service/Services/DigitalMedia/img2.png",
      baseLink: "/digitalmedia-services",
    },

    {
      id: 3,
      title: "Website Development & Optimization",
      description:
        "Your website is the digital storefront of your business. A professionally developed and optimized website not only enhances...",
      bgImgSrc: "/Assets/Images/Service/Services/DigitalMedia/bgimg3.png",
      MainImgSrc: "/Assets/Images/Service/Services/DigitalMedia/img3.png",
      baseLink: "/digitalmedia-services",
    },

    {
      id: 4,
      title: "Content Marketing",
      description:
        "Content Marketing is the art of creating valuable, relevant, and engaging content to attract, inform, and convert your target audience.",
      bgImgSrc:
        "/Assets/Images/Service/Services/DigitalMedia/content maketing.png",
      MainImgSrc: "/Assets/Images/Service/Services/DigitalMedia/img4.png",
      baseLink: "/digitalmedia-services",
    },

    {
      id: 5,
      title: "Online Reputation Management",
      description:
        "Your online reputation can make or break your brand. Online Reputation Management (ORM) involves monitoring, improving, and maintaining how your business is perceived online. Whether it’s managing reviews, responding to customer feedback, or addressing negative publicity, ORM ensures your brand’s credibility and trustworthiness remain intact.",
      bgImgSrc:
        "/Assets/Images/Service/Services/DigitalMedia/Online-Reputation-Management.png",
      MainImgSrc: "/Assets/Images/Service/Services/DigitalMedia/Online_Reputation_Management_icon.png",
      baseLink: "/digitalmedia-services",
    },

    {
      id: 6,
      title: "Search Engine Optimization (SEO)",
      description:
        "Search Engine Optimization (SEO) is the process of improving your website’s visibility on search engines like Google, Bing, and Yahoo. By optimizing your website’s structure, content, and technical aspects, SEO ensures your business appears at the top of search results when potential customers are looking for your products or services.",
      bgImgSrc:
        "/Assets/Images/Service/Services/DigitalMedia/SEO_bg.png",
      MainImgSrc: "/Assets/Images/Service/Services/DigitalMedia/SEO.png",
      baseLink: "/digitalmedia-services",
    },

    {
      id: 7,
      title: "Email Marketing",
      description:
        "Email Marketing remains one of the most effective and personalized ways to engage with your audience, nurture leads, and drive sales. By delivering tailored messages directly to your customers&#39; inboxes, you can build relationships, promote products or services, and encourage repeat business.",
      bgImgSrc:
        "/Assets/Images/Service/Services/DigitalMedia/Email_bg.png",
      MainImgSrc: "/Assets/Images/Service/Services/DigitalMedia/email_marketing.png",
      baseLink: "/digitalmedia-services",
    },

    {
      id: 8,
      title: "Influencer Marketing",
      description:
        "Influencer Marketing leverages the trust and connection influencers have with their followers to promote your brand. By collaborating with influencers across social media platforms like Instagram, YouTube, and blogs, you can reach your target audience authentically and build credibility.",
      bgImgSrc:
        "/Assets/Images/Service/Services/DigitalMedia/Influcer_marketing_bg.png",
      MainImgSrc: "/Assets/Images/Service/Services/DigitalMedia/Influencer_Marketing.png",
      baseLink: "/digitalmedia-services",
    },

    {
      id: 9,
      title: "WhatsApp Bulk Messages",
      description:
        "WhatsApp Bulk Messaging is a direct and efficient way to reach your audience. With high open rates and personalized communication, it’s ideal for promoting your products, sharing updates, and engaging with customers.",
      bgImgSrc:
        "/Assets/Images/Service/Services/DigitalMedia/watsapp_bg.png",
      MainImgSrc: "/Assets/Images/Service/Services/DigitalMedia/WhatsApp_Bulk_Messages.png",
      baseLink: "/digitalmedia-services",
    },

    {
      id: 10,
      title: "SMS Bulk Messages",
      description:
        "SMS Bulk Messaging is a fast and reliable way to communicate with your audience. With unmatched open rates and the ability to reach a wide audience, it’s perfect for promotions, reminders, and updates that get noticed.",
      bgImgSrc:
        "/Assets/Images/Service/Services/DigitalMedia/SMS-bg.png",
      MainImgSrc: "/Assets/Images/Service/Services/DigitalMedia/SMS_Bulk_Messages.png",
      baseLink: "/digitalmedia-services",
    },

    {
      id: 11,
      title: "Voice Calls / Missed Call System",
      description:
        "Voice Calls and Missed Call Systems are powerful tools for engaging with your audience in a personal and interactive way. They enable businesses to communicate important messages, capture leads, or provide customer service effectively.",
      bgImgSrc:
        "/Assets/Images/Service/Services/DigitalMedia/vdo_call_bg.png",
      MainImgSrc: "/Assets/Images/Service/Services/DigitalMedia/Voice_Calls.png",
      baseLink: "/digitalmedia-services",
    },
  ];

  return (
    <>
      <section className="Multimedia_Advertising Digital_Media">
        <div className="row">
          {data?.length > 0 &&
            data?.map((item) => {
              return (
                <div className="col-xl-4 col-md-6">
                  <Service_outer_card
                    title={item?.title}
                    description={item?.description}
                    bgImgSrc={item?.bgImgSrc}
                    MainImgSrc={item?.MainImgSrc}
                    baseLink={item?.baseLink}
                    id={item?.id}
                  />
                </div>
              );
            })}
        </div>
      </section>
    </>
  );
}

export default Digital_Media;
